import { useTranslation } from "react-i18next";
import { useBasicComponents } from "./useBasicComponent";

export const useMySQLConfig = (action = "create", defaultValues = {}) => {
  const { t } = useTranslation();
  const { replicas, core, memory, version, dataDisk, poolSize, nodegroup } =
    useBasicComponents(action, defaultValues);

  const mysqlColumns = () => {
    const group = "mysql";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
      poolSize({ group }),
    ];
  };

  const mysqlRouterColumns = () => {
    const group = "mysql-router";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
    ];
  };

  const mysqlConsoleColumns = () => {
    const group = "mysql-console";
    return [
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
    ];
  };

  const mysqlMasterColumns = () => {
    const group = "mysql-master";
    return [
      // Editable: MySQLNonHAHelm.overrideValues() reads this to build the pod's nodeSelector
      // at deploy time, and MySQLNonHAHelm.update_more() patches the live StatefulSet's
      // nodeSelector and restarts the pod on change (same mechanism as Neo4j). Only offered
      // here, not on mysql/mysql-router/mysql-console: those have no topology record in the
      // non-HA helm, so an update submitted for them is silently skipped before it ever
      // reaches a helm's update_more().
      nodegroup({ group }),
      replicas({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
    ];
  };

  const mysqlSchema = [
    {
      title: t("config.instance.form.mysql", "Mysql"),
      valueType: "group",
      columns: mysqlColumns(),
    },
    {
      title: t("config.instance.form.mysqlRouter", "Mysql Router"),
      valueType: "group",
      columns: mysqlRouterColumns(),
    },
    {
      title: t("config.instance.form.mysqlConsole", "Mysql Console"),
      valueType: "group",
      columns: mysqlConsoleColumns(),
    },
    {
      title: t("config.instance.form.mysqlMaster", "Mysql Master (Non-HA)"),
      valueType: "group",
      columns: mysqlMasterColumns(),
    },
  ];

  return mysqlSchema;
};
